import React from 'react';

interface ConversionFunnelProps {
  totalUsers: number;
  trialUsers: number;
  premiumUsers: number;
}

export function ConversionFunnel({
  totalUsers,
  trialUsers,
  premiumUsers,
}: ConversionFunnelProps) {
  const conversionRate = trialUsers > 0 ? (premiumUsers / (premiumUsers + trialUsers)) * 100 : 0;

  const stages = [
    {
      name: 'Total de Usuários',
      count: totalUsers,
      percentage: 100,
      barColor: '#b4a3ff',
    },
    {
      name: 'Em Trial',
      count: trialUsers,
      percentage: (trialUsers / totalUsers) * 100,
      barColor: '#ffa500',
    },
    {
      name: 'Premium',
      count: premiumUsers,
      percentage: (premiumUsers / totalUsers) * 100,
      barColor: '#08d660',
    },
  ];

  return (
    <div
      className="rounded-2xl p-6 backdrop-blur-sm border"
      style={{
        backgroundColor: '#111116',
        borderColor: '#1e1e25',
      }}
    >
      <div className="mb-6">
        <h3 style={{ color: '#f5f5f7' }} className="text-lg font-semibold">
          Funil de Conversão
        </h3>
        <p style={{ color: '#8a8a95' }} className="text-sm">
          Trial → Premium
        </p>
      </div>
      <div className="space-y-4">
        {stages.map((stage, index) => (
          <div key={index} className="space-y-2">
            <div className="flex justify-between items-center mb-1">
              <span style={{ color: '#8a8a95' }} className="text-sm font-medium">
                {stage.name}
              </span>
              <span style={{ color: '#f5f5f7' }} className="text-sm font-bold">
                {stage.count} ({stage.percentage.toFixed(1)}%)
              </span>
            </div>
            <div
              className="w-full rounded-full h-8 overflow-hidden"
              style={{ backgroundColor: 'rgba(138, 138, 149, 0.1)' }}
            >
              <div
                className="h-full flex items-center justify-end pr-3 transition-all duration-500"
                style={{ width: `${stage.percentage}%`, backgroundColor: stage.barColor }}
              >
                {stage.percentage > 10 && (
                  <span
                    style={{ color: '#f5f5f7' }}
                    className="text-xs font-bold drop-shadow"
                  >
                    {stage.percentage.toFixed(0)}%
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}

        <div
          className="mt-6 p-4 rounded-lg border"
          style={{
            backgroundColor: 'rgba(180, 163, 255, 0.05)',
            borderColor: '#1e1e25',
          }}
        >
          <div className="flex justify-between items-center">
            <span style={{ color: '#8a8a95' }} className="text-sm font-medium">
              Taxa de Conversão
            </span>
            <span style={{ color: '#b4a3ff' }} className="text-2xl font-bold">
              {conversionRate.toFixed(1)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
